import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Tag } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class ProductOrganisationTagsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly TAG_URL = `${this.apiServer}/product-organisation-tags`;

    getTags(productOrganisationId: number): Observable<Tag[]> {
        return this.http.get<Tag[]>(`${this.TAG_URL}/search`, {
            params: { 'productOrganisationId': `${productOrganisationId}` }
        });
    }

    updateOrRemoveTags(productOrganisationId: number, tags: string[]): Observable<Tag[]> {
        if (tags.length > 0) {
            return this.updateTags(productOrganisationId, tags);
        } else {
            return this.removeTags(productOrganisationId);
        }
    }

    private updateTags(productOrganisationId: number, tags: string[]): Observable<Tag[]> {
        return this.http.post<Tag[]>(`${this.TAG_URL}/${productOrganisationId}`, {
            tagIdList: tags
        });
    }

    private removeTags(productOrganisationId: number): Observable<Tag[]> {
        return this.http.delete(`${this.TAG_URL}/${productOrganisationId}/delete-all`)
        .pipe(map(() => []));
    }
}
